// @core/api/endpoints/chat/remove_reaction.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Remove reaction from message
 * Removes the current user's reaction of the specified emoji from the message.
 */
export async function RemoveReaction(
  conversation_id: string,
  message_id: string,
  emoji: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/reactions/:emoji`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  requestPath = requestPath.replace(':emoji', encodeURIComponent(emoji));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
